import { createContext } from "react";

const ProgressBarContext = createContext();

export default ProgressBarContext;